import { useRef, useEffect } from "react";
import gsap from "gsap";
import "./style.css";
import { MenuLinks, MenuOption } from "./MenuOptions";
import { appRoutes } from "../../routes";
import { useSelector } from "react-redux";
import {
  selectAllContent,
  selectApartmentsLink,
} from "../../features/apartments/selectors";
import { ApartmentLink } from "../../features/apartments/types";
import { Photo } from "../../api/types";
import { imagesResponse } from "../../api/responses";
import { useTranslation } from "react-i18next";

type Props = {
  isOpen: boolean;
  toggleMenu: () => void;
};

export const BurgerMenu = ({ isOpen, toggleMenu }: Props) => {
  const menuRef = useRef(null);
  //@ts-ignore
  const apartmentLinks: ApartmentLink[] = useSelector(selectApartmentsLink);
  console.log("🚀 ~ BurgerMenu ~ apartmentLinks:", apartmentLinks);
  //@ts-ignore
  const appImages: Photo[] = useSelector(selectAllContent);
  const { t } = useTranslation();

  const menuOptions: MenuOption[] = [
    {
      title: "Chi siamo",
      titleen: "About us",
      navLink: appRoutes.ABOUT,
      image: appImages[0]?.url,
    },
    {
      title: "Contatti",
      titleen: "Contact us",
      navLink: appRoutes.CONTACT,
      image: appImages[1]?.url,
    },
    {
      title: "Sostenibilità",
      titleen: "Sustainability",
      navLink: appRoutes.SUSTENIBILITY,
      image: appImages[2]?.url,
    },
    {
      title: "Case",
      titleen: "Homes",
      navLink: appRoutes.HOME,
      image: appImages[3]?.url,
      childPages: apartmentLinks ?? [
        { name: "Isola", image: imagesResponse[2].url },
      ],
    },
    {
      title: "Progetti cofinanziati",
      titleen: "Co-funded projects",
      navLink: appRoutes.COFINANCED,
      image: appImages[4]?.url,
    },
  ];

  useEffect(() => {
    const menu = menuRef.current;

    if (isOpen) {
      gsap.set(menu, { height: 0 });
      gsap.to(menu, { height: "100vh", duration: 0.3, ease: "power2.out" });
      document.body.style.overflow = "hidden";
    }
  }, [isOpen]);

  return (
    <div ref={menuRef} className={`menu ${isOpen ? "open" : ""}`}>
      <MenuLinks menuOptions={menuOptions} toggleMenu={toggleMenu} />{" "}
    </div>
  );
};
